import {
  GetShiftLocationsDocument,
  GetShiftLocationsQuery,
  GetShiftLocationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type AttendanceShiftLocationNodes =
  GetShiftLocationsQuery['attendance']['shiftLocationsConnection']['nodes']

type Props = {
  skip?: boolean
} & GetShiftLocationsQueryVariables

export const useFetchShiftLocations = ({
  skip = false,
  dateFrom,
  dateTo,
  employeeIds,
  ids,
  shiftIds,
}: Props) => {
  const { loading, data } = useQuery(GetShiftLocationsDocument, {
    variables: { dateFrom, dateTo, ids, shiftIds, employeeIds },
    skip: skip,
  })

  return {
    loading,
    shiftLocations: data
      ? (data.attendance.shiftLocationsConnection.nodes as AttendanceShiftLocationNodes)
      : undefined,
  }
}
